import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Skeleton,
} from "@mui/material";
import api from "../../utils/api";

const MemberCustomFields = ({ memberCode, context = "members" }) => {
  const [fields, setFields] = useState(null);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!memberCode) return;
    const load = async () => {
      setLoading(true);
      try {
        const [cfgRes, valRes] = await Promise.all([
          api.get("/custom-field-config/active"),
          api.get(`/members/${encodeURIComponent(memberCode)}/custom-fields`),
        ]);
        const contextKey = `show_in_${context}`;
        const filtered = (cfgRes.data || []).filter((f) => f[contextKey] !== false);
        setFields(filtered);
        setValues(valRes.data || {});
      } catch {
        setFields([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [memberCode, context]);

  if (loading) {
    return (
      <Box sx={{ mt: 2 }}>
        <Skeleton width="40%" height={20} sx={{ mb: 1 }} />
        <Skeleton width="80%" height={16} />
        <Skeleton width="60%" height={16} />
      </Box>
    );
  }

  if (!fields || fields.length === 0) return null;

  const hasAnyValue = fields.some((f) => values[f.field_key]);
  if (!hasAnyValue) return null;

  return (
    <Paper
      variant="outlined"
      sx={{ borderRadius: "12px", p: 2.5, mt: 2, borderColor: "#e3e8f0" }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 700, color: "#223142", mb: 1.5 }}
      >
        Additional Information
      </Typography>
      <Grid container spacing={1.5}>
        {fields.map((f) => {
          const val = values[f.field_key];
          if (!val) return null;
          return (
            <Grid item xs={12} sm={6} md={4} key={f.field_key}>
              <Typography variant="caption" sx={{ color: "#6b778c", display: "block" }}>
                {f.display_label}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {val}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </Paper>
  );
};

export default MemberCustomFields;
